import type { FC } from 'react';

import styled from '@mint-lib/styled';

import { Divider } from '@myn/mui';

type Props = {
  isDesktopWidth: boolean;
};

const DividerBlock: FC<Props> = ({ isDesktopWidth }) => {
  if (isDesktopWidth) {
    return <Divider orientation="vertical" flexItem />;
  }

  return <StyledDivider />;
};

export default DividerBlock;

const StyledDivider = styled(Divider)`
  width: 100%;
  margin: ${({ theme }) => `${theme.spacing(1.5)} 0px`};
`;
